import { withChildren } from "@builder.io/react";
import { Children, ReactNode, createContext, useContext, useMemo, useState } from "react";
import { AccordionContext, AccordionContextType, AccordionItemDescriptorType } from "./context";

export interface AccordionProps {
  children: ReactNode;
}

const AccordionItemIndexContext = createContext<number>(null!);

export const useAccordionItemIndex = () => {
  const context = useContext(AccordionItemIndexContext);
  if (context === null) {
    throw new Error("useAccordionItemIndex must be used within an AccordionItemIndexContext.Provider");
  }
  return context;
};

export const Accordion = withChildren(function Accordion({ children }: AccordionProps) {
  const [hovered, setHovered] = useState<AccordionItemDescriptorType | null>(null);
  const [opened, setOpened] = useState<AccordionItemDescriptorType | null>(null);

  const ctx: AccordionContextType = useMemo(
    () =>
      ({
        hovered,
        setHovered,
        opened,
        setOpened,
      }) satisfies AccordionContextType,
    [hovered, setHovered, opened, setOpened],
  );

  return (
    <AccordionContext.Provider value={ctx}>
      <div className="relative">
        {Children.map(children, (child, index) => (
          <AccordionItemIndexContext.Provider value={index + 1}>{child}</AccordionItemIndexContext.Provider>
        ))}

        {ctx.hovered?.imageURL && !ctx.opened && (
          <img
            src={ctx.hovered.imageURL}
            className="pointer-events-none absolute inset-y-0 right-18 z-10 my-9 hidden max-h-accordion-image max-w-[360px] lg:block"
          />
        )}
      </div>
    </AccordionContext.Provider>
  );
});
